var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", "max-width": "650px" } },
    [
      _c(
        "v-card",
        { staticClass: "overflow-x-hidden" },
        [
          _c("v-card-title", [
            _vm._v(" Terms of Use & Privacy Policy Agreement "),
          ]),
          _c("v-card-text", [
            _c("p", [
              _vm._v(
                " By proceeding, you acknowledge that you have read, understood, and agree to the "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://allianceretailgroup.com/terms-of-use",
                    target: "_blank",
                  },
                },
                [_vm._v("Terms of Use")]
              ),
              _vm._v(" and "),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://allianceretailgroup.com/privacy",
                    target: "_blank",
                  },
                },
                [_vm._v("Privacy Policy")]
              ),
              _vm._v(
                " governing the use of this application. These policies outline your rights and obligations as a user, including how we handle your data and ensure your privacy. "
              ),
            ]),
          ]),
          _c(
            "v-card-actions",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "v-btn",
                        {
                          style: _vm.styleObject,
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.logout.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-2", attrs: { color: "#fff" } },
                            [_vm._v("mdi-logout")]
                          ),
                          _c("span", [_vm._v("Logout")]),
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c("v-checkbox", {
                        attrs: { label: "Accept Terms & Conditions" },
                        model: {
                          value: _vm.isAccepted,
                          callback: function ($$v) {
                            _vm.isAccepted = $$v
                          },
                          expression: "isAccepted",
                        },
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-8",
                          attrs: {
                            disabled: !_vm.isAccepted,
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.update.apply(null, arguments)
                            },
                          },
                        },
                        [_c("span", [_vm._v("Confirm")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }